import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';

import { Dispatch, SetStateAction } from 'react';
import { DateTime, DateTimeResponse, mapDateTime } from './date-and-time-view-model';
import { notificationHandler } from 'src/js/notification/notification-handler';
import { TFunction } from 'i18next';
import { createUpdateDateTimeRequest } from 'src/js/model/api/request/factory/update-date-time-request-factory';

export const fetchDateTime = (setDateTime: Dispatch<SetStateAction<DateTime>>) => {
  return apiClientWithoutHandler.genericController.get<DateTimeResponse>(APIPath.datetime).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        const mapped = mapDateTime(response);
        setDateTime(mapped);
      }
    }
    return res;
  });
};

export const updateDateTime = (
  model: Partial<DateTime>,
  setDateTime: Dispatch<SetStateAction<DateTime>>,
  ptpOnly: boolean,
  t: TFunction,
) => {
  const formattedRequest = createUpdateDateTimeRequest(model);
  return apiClientWithoutHandler.genericController
    .put<DateTimeResponse>(APIPath.datetime, formattedRequest)
    .then((res) => {
      if (res.ok) {
        const response = res.data;
        if (response) {
          const datetime = mapDateTime(response);
          setDateTime(datetime);
        }
      }
      notificationHandler(
        res,
        ptpOnly ? t('settings.dateTime.notifications.successPtp') : t('settings.dateTime.notifications.success'),
        t('settings.dateTime.notifications.error'),
        t,
      );
      return res;
    });
};
